// Modal dialog (base) classes
const modalBase = 'w-full transform overflow-hidden bg-surface transition-all';

// Modal dialog (base) sizes
const modalSizes = {
  xs: 'max-w-xs rounded',
  sm: 'max-w-xl rounded',
  md: 'max-w-screen-md rounded',
  lg: 'max-w-screen-lg rounded',
  xl: 'max-w-screen-xl rounded',
  '2xl': 'max-w-screen-2xl',
  full: 'h-screen min-h-screen h-dvh min-h-dvh',
};

// Modal backdrop styles
const backdrop = 'fixed inset-0 bg-black/50 backdrop-blur-xs';

// Modal header styles
const header = 'flex justify-between items-center border-b py-4 px-6 font-bold';

// Modal body styles
const body = 'p-6';

// Modal footer classes
const footer = 'border-t py-4 px-6';

export const ModalStyles = {
  modalSizes,
  modalBase,
  backdrop,
  header,
  body,
  footer,
};
